/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import { ApplyChannelData } from '@/api/apply-product/types';
import { Component, Prop, Vue } from 'vue-property-decorator';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'NewChangeChannelList' })
export default class NewChangeChannelList extends Vue {
  @Prop(Object) readonly channelList!: ApplyChannelData[];

  private onChannelClick(channel: ApplyChannelData) {
    this.$emit('reApply', channel);
  }

  private render() {
    return (
      this.channelList.length > 0 && (
        <div class={style.channelList}>
          <div class={style.header}>您还剩余以下可借额度</div>
          {this.channelList.map((channelItem) => (
            <div
              key={channelItem.productId}
              class={style.channelItem}
              onClick={this.onChannelClick.bind(this, channelItem)}
            >
              <div class={style.channelName}>
                <div class={style.iconWrapper}>
                  <span
                    class={style.icon}
                    style={
                      channelItem.productIcon && {
                        backgroundImage: `url(${channelItem.productIcon})`,
                      }
                    }
                  />
                </div>
                <div>{channelItem.productName}</div>
              </div>

              <div class={style.amountWrapper}>
                可借额度<span class={style.amount}>{channelItem.availableAmount}</span>元
              </div>

              <div class={style.btn}>立即提现</div>
            </div>
          ))}
        </div>
      )
    );
  }
}
